"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-multi-comp */
const react_1 = __importStar(require("react"));
const Login_1 = __importDefault(require("./login/Login"));
const ForgotPassword_1 = __importDefault(require("./login/ForgotPassword"));
const Registration_1 = __importDefault(require("./login/Registration"));
const Payments_1 = __importDefault(require("./login/Payments"));
const Verify_1 = __importDefault(require("./login/Verify"));
const Invitation_1 = __importDefault(require("./login/Invitation"));
const AjaxEndpoint_1 = __importDefault(require("../common/AjaxEndpoint"));
const subscriptionUtils_1 = require("../common/subscriptionUtils");
const react_router_dom_1 = require("react-router-dom");
const ChangeEmailError_1 = __importDefault(require("./login/ChangeEmailError"));
const PasswordReset_1 = require("./login/PasswordReset");
const LoadingIndicator_1 = __importDefault(require("../realtime-ceo/modules/components/LoadingIndicator"));
const SessionExpired_1 = __importDefault(require("./login/SessionExpired"));
const EmailUpdated_1 = __importDefault(require("./login/EmailUpdated"));
var Pages;
(function (Pages) {
    Pages["Login"] = "login";
    Pages["ForgotPassword"] = "forgot";
    Pages["RegisterLoading"] = "registerloading";
    Pages["Register"] = "register";
    Pages["Payments"] = "payments";
    Pages["Verify"] = "verify";
})(Pages || (Pages = {}));
class Payment {
    constructor(params) {
        this.coupon = '';
        this.number = '';
        this.exp_year = '';
        this.exp_month = '';
        this.cvc = '';
        if (params) {
            for (let i in params) {
                if (this.hasOwnProperty(i)) {
                    this[i] = params[i];
                }
            }
        }
    }
}
function AuthLoader(props) {
    (0, react_1.useEffect)(() => {
        const { token, endpoint } = props;
        if (token) {
            endpoint.setAuthToken({ token });
            endpoint.getAccount()
                .then(account => {
                return endpoint.getUser()
                    .then(user => ({
                    account, user,
                }));
            })
                .then(data => {
                endpoint.setAuthToken(token);
                props.onUserFetched(data);
            })
                .catch(() => {
                props.onUserFailed();
            });
        }
        else {
            props.onUserFailed();
        }
        // only do once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (react_1.default.createElement(LoadingIndicator_1.default, null));
}
class LoginApp extends react_1.default.Component {
    constructor(props) {
        super(props);
        const protocol = typeof document == 'undefined' ? 'https:' : document.location.protocol;
        this.endpoint = new AjaxEndpoint_1.default('realtime', `${protocol}//${document.location.host}/`);
        this.state = {
            loginInfo: this.BlankLoginInfo,
            registrationInfo: this.BlankRegistrationInfo,
            infoMessage: null,
            errorMessage: null,
            loginError: null,
            loginWaiting: false,
            paymentsError: null,
            paymentsWaiting: false,
            registrationError: null,
            registerWaiting: false,
            page: null,
            recoveryEmail: '',
            payment: new Payment(),
            registrationToken: null,
            // invitationToken: null,
            recoverPasswordWaiting: false,
            verify_is_new_account: null,
            verify_display_email: null,
            confirmedEmail: null,
            couponData: null,
            checkingCoupon: false,
            verificationEmailResent: false,
            verificationWaiting: false,
            defaultPrice: null,
            registerError: null,
            verifyWaiting: false,
        };
        this.submitRegistration = this.submitRegistration.bind(this);
        this.submitLogin = this.submitLogin.bind(this);
        this.queryVar = this.queryVar.bind(this);
        this.submitPaymentDetails = this.submitPaymentDetails.bind(this);
        this.resetLoginDetails = this.resetLoginDetails.bind(this);
        this.resetRegistrationDetails = this.resetRegistrationDetails.bind(this);
    }
    componentDidMount() {
        // const invitationToken = this.queryVar('invitation_token')
        // //console.log("invitationToken", invitationToken);
        // if (invitationToken != null && typeof invitationToken == 'string' && invitationToken.length > 0) {
        //     this.setState({
        //         // page: Pages.Register,
        //         invitationToken: invitationToken,
        //     })
        // }
        // console.log('loginapp')
        // if (this.state.page === Pages.RegisterLoading) {
        //     const token = this.queryVar('token')
        //     console.log('token?', token)
        // }
        const confirmed_email = this.queryVar('confirmed_email');
        if (confirmed_email != null && typeof confirmed_email == 'string' && confirmed_email.length > 0) {
            const newLoginInfo = this.state.loginInfo;
            newLoginInfo.email = confirmed_email;
            this.setState({
                confirmedEmail: confirmed_email,
                loginInfo: newLoginInfo,
            });
        }
        this.endpoint.getSubscriptionPrice()
            .then(response => {
            this.setState({
                //price is in cents
                defaultPrice: response.amount / 100,
            });
        });
    }
    showScreen(newScreen, func) {
        if (func != undefined) {
            func();
        }
        switch (newScreen) {
            case Pages.Login:
                return window.location.href = '/login';
            case Pages.ForgotPassword:
                return window.location.href = '/forgotpassword';
            case Pages.Register:
                return window.location.href = '/register';
        }
        this.setState({
            page: newScreen,
            loginError: null,
            registrationError: null,
            infoMessage: null,
            errorMessage: null,
            recoveryEmail: null,
        });
    }
    resetLoginDetails() {
        this.setState({ loginInfo: { email: '', password: '' } });
    }
    get BlankLoginInfo() {
        return {
            email: '',
            password: '',
        };
    }
    get BlankRegistrationInfo() {
        return {
            email: '',
            password: '',
            first_name: '',
            last_name: '',
            industry: '',
            invitation_token: '',
            business_name: '',
        };
    }
    resetRegistrationDetails() {
        this.setState({
            registrationInfo: this.BlankRegistrationInfo,
        });
    }
    getDefaultPrice() {
        return this.state.defaultPrice;
    }
    getRegistrationInfoText() {
        const price = this.getDefaultPrice();
        const priceText = price === null ? '' : `Normally $${price} AUD per month`;
        return (react_1.default.createElement("div", { className: "text-center" },
            react_1.default.createElement("p", null, "The first month is Free!"),
            react_1.default.createElement("p", null, "You can cancel at anytime online"),
            react_1.default.createElement("p", null,
                priceText,
                react_1.default.createElement("br", null),
                "(plus 10% GST if you are located in Australia)")));
    }
    queryVar(name) {
        return this.queryVarOf(name, location.search);
    }
    queryVarOf(name, search) {
        const escaped = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        const regex = new RegExp('[\\?&]' + escaped + '=([^&#]*)');
        const results = regex.exec(search);
        return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
    }
    submitLogin() {
        const { loginInfo } = this.state;
        // Move to appropriate screen if user can log in but has not subscribed or verified?
        //
        // if authenticated, get acc + user data
        // and redirect to appropriate page if they haven't subscribed or verified email
        // Only used within this function, used to prevent the next page being overwritten
        // by a later account/user details check
        let nextPage = null;
        // Need to pass endpoint authresponse to more code later (registration, login if all successful)
        let authResponse = null;
        return this.startIndicator(Pages.Login)
            .then(() => this.endpoint.auth(loginInfo.email, loginInfo.password)
            .catch(response => {
            if (response.status == 401) {
                throw 'Invalid credentials!';
            }
        }))
            .then(response => {
            authResponse = response;
            this.endpoint.setAuthToken(authResponse);
        })
            // Start checking account details
            .then(() => this.endpoint.getAccount()
            .catch(() => {
            throw 'Could not get Account details.';
        }))
            .then(acc_details => {
            if (acc_details.never_subscribed && (acc_details.last_four_digits == null)) {
                window.location.href = '/register?token=' + this.endpoint.AuthToken;
                nextPage = Pages.Payments;
            }
        })
            .then(() => this.endpoint.getUser()
            .catch(() => {
            throw 'Could not get User details.';
        }))
            .then(user_details => {
            if (user_details.email_confirmed == false) {
                if (nextPage == null) {
                    window.location.href = '/register?token=' + this.endpoint.AuthToken;
                    nextPage = Pages.Verify;
                }
            }
        })
            // If everything is okay, log in!
            .then(() => {
            if (nextPage == null) {
                this.loginWithTokenResponse(authResponse);
            }
        })
            .catch(errorMsg => {
            //if( typeof errorMsg !== "undefined" && nextPage == null) {
            const e_msg = typeof errorMsg !== 'string' ? 'An error occurred.' : errorMsg;
            this.setState({
                loginError: e_msg,
                loginWaiting: false,
            });
            // }
        })
            .then(() => this.setState({
            registerWaiting: false
        }));
    }
    loginWithTokenResponse(response) {
        return new Promise((resolve, reject) => {
            window.location.href = `/?token=${response.token}`;
            this.clearLoadingIndicator();
            resolve(response);
        });
    }
    clearLoadingIndicator() {
        this.setState({
            loginWaiting: false,
            registerWaiting: false,
        });
    }
    isEmail(email) {
        const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    }
    submitForgot() {
        const { recoveryEmail } = this.state;
        //already validated by form
        //        if (this.isEmail(recoveryEmail) == false) {
        //            return;
        //        }
        this.startIndicator(Pages.ForgotPassword)
            .then(() => this.endpoint.resetPassword(recoveryEmail))
            .then(() => {
            this.setState({
                infoMessage: `Password reset has been successfully sent to ${recoveryEmail}`,
                registerWaiting: false,
            });
        })
            .catch(response => {
            //                if (response.status < 500) {
            if (response.status == 401) {
                response
                    //TODO josn() is not a function!
                    .json()
                    .then(parsed => this.setState({
                    errorMessage: 'There is no account associated with that email address.',
                    registerWaiting: false,
                }))
                    .catch(e => this.setState({
                    errorMessage: 'There was a error with your request.',
                    registerWaiting: false,
                }));
            }
            else {
                this.setState({
                    errorMessage: 'There was a error with your request.',
                    registerWaiting: false,
                });
            }
        });
    }
    submitRegistration() {
        // const invitationToken = this.state.invitationToken
        const registrationInfo = this.state.registrationInfo;
        const data = {
            first_name: registrationInfo.first_name,
            last_name: registrationInfo.last_name,
            business_name: registrationInfo.business_name,
            email: registrationInfo.email,
            password: registrationInfo.password,
            industry: registrationInfo.industry,
        };
        // if (invitationToken != null && typeof invitationToken == 'string') {
        //     data.invitation_token = invitationToken
        // }
        return this
            .startIndicator(Pages.Register)
            .then(() => this.endpoint.registration(data))
            .then((response) => {
            this.endpoint.setAuthToken(response);
            // if (invitationToken != null) {
            //     // If they were invite, go straight to logging them in
            //     return this.loginWithTokenResponse(response)
            // } else {
            // If it's the initial registration, go to subscription details screen.
            this.setState({
                page: Pages.Payments,
                registerWaiting: false,
                registrationToken: response.token,
                verify_display_email: registrationInfo.email,
            });
            return Promise.resolve();
            // }
        })
            .catch((response) => {
            response
                .json()
                .then(parsed => this.setState({
                registrationError: parsed.message,
                registerWaiting: false,
            }))
                .catch(err => this.setState({
                registrationError: 'Error creating account.',
                registerWaiting: false,
            }));
        });
    }
    startIndicator(page) {
        switch (page) {
            case Pages.Login:
                return Promise.resolve(this.setState({
                    loginWaiting: true,
                    loginError: null,
                }));
                break;
            case Pages.Verify:
                return Promise.resolve(this.setState({
                    loginWaiting: true,
                    loginError: null,
                }));
                break;
            // case Pages.Info:
            //     break
            case Pages.Payments:
                return Promise.resolve(this.setState({
                    paymentsWaiting: true,
                    paymentsError: null,
                }));
                break;
            case Pages.ForgotPassword:
            case Pages.Register:
                return Promise.resolve(this.setState({
                    registerWaiting: true,
                    registerError: null,
                }));
                break;
            default:
                return Promise.reject(false);
                break;
        }
    }
    submitPaymentDetails() {
        const { payment, registrationToken } = this.state;
        return this
            .startIndicator(Pages.Payments)
            .then(() => this.endpoint.submitPaymentDetails(payment, registrationToken)
            .catch(response => {
            //determine the error type and break out of the chain
            return response
                .json()
                .then(parsed => {
                this.setState({
                    paymentsError: parsed.message,
                    paymentsWaiting: false,
                });
                return parsed;
            })
                .catch(err => {
                this.setState({
                    paymentsError: 'Subscription has failed.',
                    paymentsWaiting: false,
                });
                return err;
            })
                .then(err => { throw err; });
        }))
            .then(() => this.endpoint.getUser()
            .catch(() => {
            throw 'Could not get User details.';
        }))
            .then(user_details => {
            if (user_details['email_confirmed'] == true) {
                window.location.href = `/index.html?token=${registrationToken}`;
            }
            else {
                this.setState({
                    page: Pages.Verify,
                    verify_is_new_account: true,
                    verify_display_email: user_details['email'],
                    loginWaiting: false,
                    loginError: null,
                });
            }
        })
            .catch(errorMsg => {
            const e_msg = typeof errorMsg !== 'string' ? 'An error occurred.' : errorMsg;
            this.setState({
                loginError: e_msg,
                loginWaiting: false,
            });
        });
    }
    onSubmit() {
        const form = document.getElementById('login-form');
        if (form.checkValidity()) {
            // DO NOTHING;
        }
        else {
            return false;
        }
    }
    registrationInfoChange(key, newValue) {
        const info = this.state.registrationInfo;
        if (typeof newValue !== 'string') {
            this.setState({
                registrationError: 'Error - was unable to change value'
            });
        }
        info[key] = newValue;
        this.setState({
            registrationInfo: info,
        });
    }
    loginInfoChange(key, newValue) {
        let info = this.state.loginInfo;
        info[key] = newValue;
        this.setState({
            loginInfo: info,
        });
    }
    getForgotPassword() {
        const { recoveryEmail, infoMessage, errorMessage, registerWaiting } = this.state;
        return (react_1.default.createElement(ForgotPassword_1.default, { waiting: registerWaiting, infoMessage: infoMessage, errorMessage: errorMessage, onBackPressed: () => this.showScreen(Pages.Login), onSubmit: () => this.submitForgot(), recoveryEmail: recoveryEmail, onChange: value => this.setState({ recoveryEmail: value }) }));
    }
    getResetPassword(token, resetErrorMessage) {
        return (react_1.default.createElement(PasswordReset_1.PasswordReset, { errorMessage: resetErrorMessage, token: token !== null && token !== void 0 ? token : '' }));
    }
    onChangePaymentInfo(key, newValue) {
        const { payment } = this.state;
        payment[key] = newValue;
        this.setState({
            payment: new Payment(payment),
        });
        if (key == 'coupon') {
            this.setState({
                checkingCoupon: true,
                payment: new Payment(payment),
            });
            this.endpoint.checkCoupon(newValue)
                .then(result => this.setState({
                couponData: result,
                checkingCoupon: false,
            }))
                .catch(() => this.setState({
                couponData: null,
                checkingCoupon: false,
            }));
        }
    }
    get Register() {
        const { registerWaiting, registrationInfo, registrationError } = this.state;
        // message={string} // User receives a message if email is confirmed.
        // invitation_token={string} // User has clicked a link from their email.
        const waitingForPrice = this.getDefaultPrice() === null;
        return (react_1.default.createElement(Registration_1.default, { info_text: this.getRegistrationInfoText(), waiting: registerWaiting || waitingForPrice, registrationInfo: registrationInfo, onChange: (key, newValue) => this.registrationInfoChange(key, newValue), onCancel: () => this.showScreen(Pages.Login, this.resetRegistrationDetails), onSubmit: () => this.submitRegistration(), message: this.queryVar('message'), token: this.queryVar('token'), 
            // inviteToken={this.state.invitationToken}
            registrationError: registrationError }));
    }
    getInvitation(token) {
        return (react_1.default.createElement(Invitation_1.default, { endpointService: this.endpoint, token: token, onCancel: () => this.showScreen(Pages.Login) }));
    }
    get Payments() {
        const { paymentsError, paymentsWaiting } = this.state;
        const couponMessage = this.getCouponDescriptionText(this.getDefaultPrice());
        return (react_1.default.createElement(Payments_1.default, { info_text: this.getRegistrationInfoText(), waiting: paymentsWaiting, errorMessage: paymentsError, cancel: () => this.showScreen(Pages.Login), onSubmit: () => this.submitPaymentDetails(), payment: this.state.payment, couponMessage: couponMessage, onChange: (key, newValue) => this.onChangePaymentInfo(key, newValue) }));
    }
    get Login() {
        const { loginWaiting, loginInfo, loginError, confirmedEmail } = this.state;
        return (react_1.default.createElement(Login_1.default, { waiting: loginWaiting, email: confirmedEmail, loginInfo: loginInfo, onChange: (key, newValue) => this.loginInfoChange(key, newValue), loginError: loginError, message: this.queryVar('message'), onSubmit: () => this.submitLogin(), forgot: () => this.showScreen(Pages.ForgotPassword, this.resetLoginDetails), register: () => this.showScreen(Pages.Register, this.resetLoginDetails) }));
    }
    get Verify() {
        const { verify_display_email, verify_is_new_account, verificationEmailResent, verifyWaiting } = this.state;
        const onResendVerification = verificationEmailResent ? null : () => this.resendVerification();
        return (react_1.default.createElement(Verify_1.default, { is_new_account: verify_is_new_account, email_address: verify_display_email, onResendVerification: onResendVerification, waiting: verifyWaiting }));
    }
    getCouponDescriptionText(basePrice) {
        const { couponData, checkingCoupon, payment } = this.state;
        return (0, subscriptionUtils_1.getCouponDescriptionText)(basePrice, payment.coupon, couponData, checkingCoupon);
    }
    resendVerification() {
        this.setState({
            verifyWaiting: true,
        });
        this.endpoint.resendVerificationEmail()
            .then(() => this.setState({
            verificationEmailResent: true,
        }))
            .catch((e) => console.error('error resending:', e))
            .then(() => this.setState({
            verifyWaiting: false,
        }));
    }
    getRegisterPage(invitationToken, loginToken) {
        if (invitationToken) {
            return this.getInvitation(invitationToken);
        }
        if (invitationToken) {
            return this.getInvitation(invitationToken);
        }
        switch (this.state.page) {
            case Pages.Payments:
                return this.Payments;
            case Pages.Verify:
                return this.Verify;
            case Pages.Register:
                return this.Register;
            default:
                return (react_1.default.createElement(AuthLoader, { endpoint: this.endpoint, token: loginToken, onUserFetched: ({ account, user }) => {
                        if (!account.active_subscription && account.never_subscribed) {
                            this.setState({
                                registrationToken: this.endpoint.token,
                            }, () => {
                                this.showScreen(Pages.Payments);
                            });
                        }
                        else if (!user.email_confirmed) {
                            this.setState({
                                verify_display_email: user.email,
                                registrationToken: this.endpoint.token,
                            }, () => {
                                this.showScreen(Pages.Verify);
                            });
                        }
                        else {
                            this.setState({
                                page: Pages.Register,
                            });
                        }
                    }, onUserFailed: () => {
                        this.setState({
                            page: Pages.Register,
                        });
                    } }));
        }
    }
    render() {
        return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null,
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { path: "/resetpassword" }, (routeProps) => this.getResetPassword(this.queryVarOf('token', routeProps.location.search || ''), this.queryVarOf('error_message', routeProps.location.search || ''))),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/forgotpassword" }, this.getForgotPassword()),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/changeemailerror" },
                    react_1.default.createElement(ChangeEmailError_1.default, { onCancel: () => this.showScreen(Pages.Login) })),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/register" }, (routeProps) => this.getRegisterPage(this.queryVarOf('invitation_token', routeProps.location.search || ''), this.queryVarOf('token', routeProps.location.search || ''))),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/sessionexpired" },
                    react_1.default.createElement(SessionExpired_1.default, { gotoLogin: () => {
                            window.location.href = '/login';
                        } })),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/emailupdated" }, (routeProps) => {
                    const email = this.queryVarOf('confirmed_email', routeProps.location.search);
                    return (react_1.default.createElement(EmailUpdated_1.default, { gotoLogin: () => {
                            if (email) {
                                window.location.href = `/login?confirmed_email=${encodeURIComponent(email)}`;
                            }
                            else {
                                window.location.href = '/login';
                            }
                        }, email: email }));
                }),
                react_1.default.createElement(react_router_dom_1.Route, { path: "/" }, this.Login))));
    }
}
exports.default = LoginApp;
